import { WorkDays } from '@/types';
import { signal } from '@preact/signals';

export const workDaysSignal = signal<WorkDays>({});
